import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import { AutoInviteRule } from './autoInviteTypes'
import { hasConditionValue } from 'features/RuleBuilder'

const BASE_PATH = '/hr/profile/auto_invite_rules/'

const clearedSecondary = {
  secondaryField: null,
  secondaryOperator: null,
  secondaryValue: null,
  conditionJoin: null,
}

const clearedTertiary = {
  tertiaryField: null,
  tertiaryOperator: null,
  tertiaryValue: null,
  tertiaryConditionJoin: null,
}

const autoInviteRuleToApiBody = (payload: AutoInviteRule) => {
  if (payload.scope === 'ALL_NEW') {
    return {
      scope: 'ALL_NEW',
      field: null,
      operator: null,
      value: null,
      ...clearedSecondary,
      ...clearedTertiary,
    }
  }

  const field = payload.field
  const operator = payload.operator ?? 'equals'
  const value = payload.value ?? ''

  const secondaryOperator = payload.secondaryOperator ?? 'equals'
  const hasSecondary =
    Boolean(payload.secondaryField) &&
    hasConditionValue(payload.secondaryValue ?? '', secondaryOperator)
  const tertiaryOperator = payload.tertiaryOperator ?? 'equals'
  const hasTertiary =
    hasSecondary &&
    Boolean(payload.tertiaryField) &&
    hasConditionValue(payload.tertiaryValue ?? '', tertiaryOperator)

  const base = {
    scope: 'MATCHING' as const,
    field,
    operator,
    value,
  }

  if (!hasSecondary) {
    return { ...base, ...clearedSecondary, ...clearedTertiary }
  }

  const withSecondary = {
    ...base,
    secondaryField: payload.secondaryField,
    secondaryOperator,
    secondaryValue: payload.secondaryValue,
    conditionJoin: payload.conditionJoin ?? 'and',
  }

  if (!hasTertiary) {
    return { ...withSecondary, ...clearedTertiary }
  }

  return {
    ...withSecondary,
    tertiaryField: payload.tertiaryField,
    tertiaryOperator,
    tertiaryValue: payload.tertiaryValue,
    tertiaryConditionJoin: payload.tertiaryConditionJoin ?? 'and',
  }
}

const getAutoInviteRules = (): Promise<AxiosResponse<AutoInviteRule[]>> => {
  return Request.get(BASE_PATH)
}

const modifyAutoInviteRule = (
  id: string,
  payload: AutoInviteRule
): Promise<AxiosResponse<AutoInviteRule>> => {
  return Request.put(`${BASE_PATH}${id}/modify/`, autoInviteRuleToApiBody(payload))
}

export default {
  getAutoInviteRules,
  modifyAutoInviteRule,
}
